<template>
    <el-dialog
        :visible.sync="visible"
        width="30%"
        :before-close="handleClose">
    <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="增加文件" name="first">
      <div style="display: flex;">
        <div style="display:inline-block;width: 50%;">
            <span>选择需要增加的文件</span>
            <el-tree
            :data="data"
            :props="defaultProps"
            show-checkbox
            check-strictly=true
            node-key="id">
            </el-tree>
        </div>
        
        <div style="display:inline-block;width: 50%;">
            <span>当前项目</span>
            <el-tree
            :data="data2.children"
            node-key="id">
            </el-tree>
         </div>
         </div>
        <el-button type='primary'>确认移动</el-button>
    </el-tab-pane>
    <el-tab-pane label="移出文件" name="second">
        <div style="display: flex;">
        <div style="display:inline-block;width: 50%;">
            <span>选择需要移出的文件</span>
            <el-tree
            :data="data"
            :props="defaultProps"
            show-checkbox
            check-strictly=true
            node-key="id">
            </el-tree>
        </div>
        
        <div style="display:inline-block;width: 50%;">
            <span>选择移出的项目</span>
            <el-tree
            :data="data1"
            show-checkbox
            check-strictly=true
            node-key="id">
            </el-tree>
         </div>
         </div>
        <el-button type='primary'>确认移动</el-button>
        </el-tab-pane>
    </el-tabs>
    </el-dialog>
</template>

<script>
  export default {
    name:'EditProject',
    data() {
      return {
        activeName:'second',
        visible:false,
        data: [{
            id: 3,
            label: '我的项目',
            children: [{
              id: 4,
              label: 'battery_01.csv'
            }, {
              id: 5,
              label: 'battery_02.csv',    
            }]
          }, {
            id: 2,
            label: '其他数据',
            disabled: true,
            children: [{
              id: 6,
              label: 'battery_03.csv'
            }, {
              id: 7,
              label: 'battery_04.csv',
            }]
          },
          {
            id: 10,
            label: '我的项目',
            children: [{
              id: 4,
              label: 'battery_01.csv'
            }, {
              id: 5,
              label: 'battery_02.csv',    
            }]
          },
          {
            id: 11,
            label: '我的项目',
            children: [{
              id: 4,
              label: 'battery_01.csv'
            }, {
              id: 5,
              label: 'battery_02.csv',    
            }]
          }],
          data1:[{
            id: 3,
            label: '我的项目',
            children: [{
              id: 4,
              label: 'battery_01.csv'
            }, {
              id: 5,
              label: 'battery_02.csv',    
            }]
          }, {
            id: 2,
            label: '其他数据',
            children: [{
              id: 6,
              label: 'battery_03.csv'
            }, {
              id: 7,
              label: 'battery_04.csv',
            }]
          },
          {
            id: 10,
            label: '我的项目',
            children: [{
              id: 4,
              label: 'battery_01.csv'
            }, {
              id: 5,
              label: 'battery_02.csv',    
            }]
          },
          {
            id: 11,
            label: '我的项目',
            children: [{
              id: 4,
              label: 'battery_01.csv'
            }, {
              id: 5,
              label: 'battery_02.csv',    
            }]
          }],
          data2:{
            id: 3,
            label: '我的项目',
            children: [{
              id: 4,
              label: 'battery_01.csv'
            }, {
              id: 5,
              label: 'battery_02.csv',    
            }]
          }
     }
    },
    created(){
        this.data1.forEach(
            item=>{
                item.children.forEach(
                    it=>
                        it.disabled='false'
                    )})
    
        this.data.forEach(
            item=>{
                item.disabled='false'
                    })
        // console.log(this.data1)
    },
    props:{
        isShow:{
            type:Boolean,
            required:true,
            default:false,
        }
    },
    methods:{
        handleClose(){
            this.visible=false
            this.$emit('closeEditDialog')
        }
    },
    watch:{
        isShow:{
            handler(newVal){
                this.visible=newVal
                // console.log(oldVal)
            }
            
        }
    }
  };
</script>